import { apiGet, apiPatch } from './client';
import type {
  BFIXRateType,
  BFIXRateTypeBatchRequest,
} from '../types/BFIXRateType';

export function getBfixRateTypes(): Promise<BFIXRateType[]> {
  return apiGet<BFIXRateType[]>('/api/bfix-rate-types');
}

export function saveBfixRateTypesBatch(
  added: BFIXRateType[],
  modified: BFIXRateType[],
  deletedIds: number[],
): Promise<BFIXRateType[]> {
  return apiPatch<BFIXRateTypeBatchRequest, BFIXRateType[]>(
    '/api/bfix-rate-types/batch',
    { added, modified, deleted: deletedIds },
  );
}
